import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { CommonService } from '../../../services/common/common.service'

@Component({
  selector: 'app-reddi-distance-radio-button',
  templateUrl: './reddi-distance-radio-button.component.html',
  styleUrls: ['./reddi-distance-radio-button.component.scss'],
  standalone: false,
})
export class ReddiDistanceRadioButtonComponent implements OnInit {
  @Output() selectionChange = new EventEmitter<string>()
  constructor(
    private translateService: TranslateService,
    private commonService: CommonService,
  ) {}

  labels: string[] = ['0.5 - 0.9', '1 - 1.9', '2 - 3.9', '4 - 7.9']
  selected: string | null = null
  title: string = this.commonService.translateSafe('Distance metres')

  ngOnInit() {
    this.translateService.onLangChange.subscribe(() => {
      this.updateTitle()
    })
  }

  updateTitle(): void {
    this.title = this.commonService.translateSafe('Distance metres')
  }

  onSelectionChange(label: string): void {
    if (this.selected === label) {
      this.selected = null
    } else {
      this.selected = label
    }
    this.selectionChange.emit(this.selected)
  }
}
